// Product catalog content for My Eco Engineer

export const PRODUCTS = [
  {
    slug: "low-tox-home-blueprint",
    name: "The Low-Tox Home Blueprint",
    type: "Blueprint",
    image: "https://images.unsplash.com/photo-1721244653721-bc681b2dfd27?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
    positioning: "An engineering-based guide for renovating, building, or moving into a healthier home.",
    descriptor: "A residential environmental design manual",
    family: "environmental",
    status: "available", // available | waitlist
    price: "$247",
    cta: "Purchase The Low-Tox Home Blueprint",
    overview:
      "The Low-Tox Home Blueprint is a practical residential environmental design manual for people renovating, building, buying, or improving a home. It gives homeowners a systems-based framework for making better decisions about materials, air, water, furnishings, testing, contractors, sequencing, and long-term maintenance.",
    includes: [
      "Designed Brand PDF version, the full, branded manual (best for reading on screen)",
      "Plain Text PDF version, print-friendly and easy to search",
      "The complete residential environmental design manual (300+ pages)",
      "Section I: Foundations, 9 chapters on mindset, materials, air, water, furnishings, testing, teams, and sequencing",
      "Section II: Project Blueprints, buying an existing home, renovation, and new construction",
      "Section III: Residential Environmental Design Reference, materials, mechanical, water, and interior living guides",
      "Section IV: Tools & Worksheets, assessments, checklists, logs, and planners",
      "Section V: Appendices, glossary, references, standards, certifications, and index",
    ],
    note: "This Blueprint is educational and decision-support material. It does not provide medical, legal, engineering, architectural, code-compliance, or construction advice. Homeowners should work with qualified professionals where appropriate.",
    designed_for: [
      "Homeowners planning renovations or new construction",
      "Individuals moving into new or existing homes",
      "Households seeking to reduce cumulative environmental exposure",
      "Households with respiratory sensitivity or chronic conditions",
      "Time-constrained decision-makers who require structured frameworks and prioritization",
    ],
    scope: [
      "Systems-based exposure framework",
      "Home Toxicity Priority Matrix",
      "Material selection strategy (flooring, walls, cabinetry, insulation)",
      "Air quality engineering and ventilation design",
      "Moisture and mold risk mitigation",
      "Combustion appliance analysis (gas vs induction)",
      "Water contamination pathways and filtration selection",
      "Testing strategy (air, water, moisture, dust)",
      "Contractor communication protocols",
      "Capital planning and implementation sequencing",
      "Renovation, new build, and relocation blueprints",
    ],
    architecture: [
      { t: "Section I, Foundations (Define the System)", d: "Establishes exposure pathways, core building science principles, and the decision frameworks used to evaluate materials, air, water, and construction practices." },
      { t: "Section II, Scenario Frameworks (Apply the System)", d: "Translates core principles into structured approaches for renovation, new construction, and relocation, with step-by-step decision sequencing." },
      { t: "Section III, Tools and Resources (Execute the System)", d: "Provides checklists, templates, and reference tools to support implementation, contractor coordination, and ongoing system management." },
    ],
    not_do: [
      "Does not replace licensed architects, engineers, contractors, or other qualified professionals",
      "Does not provide project-specific design, engineering, or construction advice",
      "Does not eliminate all environmental exposure",
      "Does not guarantee health outcomes or symptom resolution",
      "Does not account for all site-specific conditions, materials, or variables",
    ],
    format: ["Two PDF downloads: Designed Brand + Plain Text", "300+ page residential design manual", "Instant delivery after purchase", "Printable worksheets and structured checklists", "Lifetime access, including future updates"],
  },
  {
    slug: "cognitive-load-allocation-framework",
    name: "Cognitive Load & Allocation Framework",
    type: "Framework",
    image: "https://images.unsplash.com/photo-1711025372958-db48a4fe0ba1?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
    positioning: "A system for measuring, allocating, and governing cognitive load across households, partnerships, and teams.",
    descriptor: "Cognitive load governance system",
    family: "household",
    status: "waitlist",
    price: null,
    cta: "Join Waitlist",
    overview:
      "Modern systems do not fail from lack of effort. They fail from unmanaged load. Cognitive load accumulates through decision density, risk evaluation, anticipation, coordination, and responsibility tracking. Much of this load remains invisible, unmeasured, and unevenly distributed. The Cognitive Load & Allocation Framework defines cognitive load as a finite operational resource and establishes a system for making that load visible, measurable, and governable over time. This is not a mindset tool. It is a system for governing cognitive load as a finite operational resource.",
    designed_for: [
      "Partnerships with uneven or invisible load distribution",
      "Individuals entering or restructuring shared household systems",
      "Households operating as interdependent systems",
      "Founders and operators managing overlapping personal and operational demands",
      "Individuals carrying high cognitive responsibility across domestic and personal domains",
      "Small teams or collaborative groups without formal load allocation structures",
    ],
    scope: [
      "Distinguishing internal vs external load",
      "Measuring load density and accumulation over time",
      "Allocating load using defined system constraints",
      "Establishing reporting structures to govern distribution",
    ],
    architecture: [
      { t: "Measurement Layer", d: "Quantifies cognitive load across individuals and domains using structured inputs and defined variables." },
      { t: "Allocation Layer", d: "Distributes load based on capacity, constraints, and system requirements rather than default or assumption." },
      { t: "Governance Layer", d: "Establishes reporting, review cycles, and adjustment mechanisms to maintain balance over time." },
    ],
    not_do: [
      "Does not replace professional counseling, coaching, or medical care",
      "Does not resolve interpersonal conflict independently",
      "Does not eliminate workload, only enables the restructuring and redistribution of it",
      "Does not guarantee performance, relationship, or organizational outcomes",
    ],
    format: ["Digital PDF download", "Instant access upon purchase", "Printable worksheets and structured tools"],
  },
  {
    slug: "decision-systems-toolkit",
    name: "Decision Systems Toolkit",
    type: "Toolkit",
    image: "https://images.unsplash.com/photo-1560174038-da43ac74f01b?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
    positioning: "Structured tools for evaluating risk, prioritizing interventions, and managing exposure decisions.",
    descriptor: "Decision frameworks & prioritization tools",
    family: "household",
    status: "waitlist",
    price: null,
    cta: "Join Waitlist",
    overview:
      "A toolkit of structured decision frameworks for evaluating risk, prioritizing interventions, and allocating limited capacity across exposure decisions. Full details are in development.",
    designed_for: [],
    scope: [],
    architecture: [],
    not_do: [],
    format: ["Digital PDF download", "Instant access upon purchase"],
  },
  {
    slug: "organizational-cognitive-load-framework",
    name: "Organizational Cognitive Load Framework",
    type: "Framework",
    family: "organizational",
    image: "https://images.unsplash.com/photo-1497366216548-37526070297c?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
    positioning: "A structured system for measuring, allocating, and governing cognitive load across teams and organizations.",
    descriptor: "Organizational cognitive load governance",
    status: "coming-soon",
    price: null,
    cta: "Join Waitlist",
    overview:
      "Organizations rarely fail from a lack of effort. They fail from unmanaged cognitive load, distributed unevenly and invisibly across teams. This framework applies the same engineering methodology behind our environmental work to organizational capacity, making decision load visible, measurable, and governable so performance stays sustainable as an organization scales.",
    designed_for: [],
    scope: ["Decision density", "Responsibility allocation", "Meeting overload", "Communication flow", "Organizational capacity", "Sustainable performance"],
    architecture: [],
    not_do: [],
    format: ["Digital system", "Coming soon"],
  },
  {
    slug: "decision-architecture-toolkit",
    name: "Decision Architecture Toolkit",
    type: "Toolkit",
    family: "organizational",
    image: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
    positioning: "Templates, decision matrices, governance models, AI prompts, and structured implementation tools that improve organizational decision quality and operational consistency.",
    descriptor: "Organizational decision tools & templates",
    status: "coming-soon",
    price: null,
    cta: "Join Waitlist",
    overview:
      "Consistent decisions require consistent structure. The Decision Architecture Toolkit provides the templates, matrices, governance models, and AI prompts that turn organizational decision-making into a repeatable, engineered process rather than an ad-hoc one.",
    designed_for: [],
    scope: ["Decision matrices", "Governance models", "Operating templates", "AI prompt libraries", "Implementation playbooks"],
    architecture: [],
    not_do: [],
    format: ["Digital toolkit", "Coming soon"],
  },
  {
    slug: "ai-workflow-blueprint",
    name: "AI Workflow Blueprint",
    type: "Blueprint",
    family: "organizational",
    image: "https://images.unsplash.com/photo-1526628953301-3e589a6a8b74?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
    positioning: "A practical implementation guide for identifying repetitive work, redesigning workflows, documenting processes, and integrating AI into everyday operations.",
    descriptor: "AI-assisted workflow implementation guide",
    status: "coming-soon",
    price: null,
    cta: "Join Waitlist",
    overview:
      "AI adoption fails when it's bolted onto broken workflows. This blueprint applies structured process engineering first, identifying repetitive work, redesigning workflows, and documenting operations, then integrates AI where it measurably improves consistency and capacity.",
    designed_for: [],
    scope: ["Repetitive work identification", "Workflow redesign", "Process documentation", "AI integration", "Operational consistency"],
    architecture: [],
    not_do: [],
    format: ["Digital guide", "Coming soon"],
  },
];

// One engineering methodology applied across three connected practice areas.
export const PRODUCT_FAMILIES = [
  {
    key: "environmental",
    name: "Environmental Systems",
    blurb: "Engineering healthier homes through structured evaluation of cumulative environmental exposure.",
    status: "Available now",
    future: "Kitchen, Water, and Air Blueprints coming next.",
  },
  {
    key: "household",
    name: "Household Systems",
    blurb: "Engineering more resilient households through better decision-making and cognitive load management.",
    status: "In development",
    future: "Household Operating Systems on the roadmap.",
  },
  {
    key: "organizational",
    name: "Organizational Systems",
    blurb: "Engineering higher-performing organizations through structured decision systems, workflow optimization, cognitive load management, and AI-assisted operations.",
    status: "Coming soon",
    future: "Meeting OS, Capacity Planning, and AI Governance to follow.",
  },
];

export const productBySlug = (slug) => PRODUCTS.find((p) => p.slug === slug);

export const CONTACT_EMAIL = "info@myecoengineer.com";
